import { render, staticRenderFns } from "./FeedbackReasonGroupTable.vue?vue&type=template&id=03cb99f7&scoped=true&"
import script from "./FeedbackReasonGroupTable.vue?vue&type=script&lang=js&"
export * from "./FeedbackReasonGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cb99f7",
  null
  
)

export default component.exports